import { DesignItemModel } from '@features/elite-form/models/elite-form-design-item-model';
import { Subject } from "rxjs";
import { ReplaySubject } from "rxjs";
import { Guid } from "guid-typescript";
import { PageGroupItem } from '../models/elite-form-common-data-models';
import {filter, map} from "rxjs/operators";
import {BehaviorSubject} from "rxjs";

export class EliteFormManagerService {
  private _id: string;
  _fieldVisibilities: ReplaySubject<any[]>;
  _formChanged$: ReplaySubject<any[]>;
  _groupVisibilities: ReplaySubject<any[]>;
  //
  fieldPositionChanged$: ReplaySubject<any[]>;
  fieldResized$: ReplaySubject<any[]>;
  fieldLayoutChanged$: ReplaySubject<any[]>;
  constructor() {
    this._id = Guid.create().toString();
    this._fieldVisibilities = new ReplaySubject();
    this._formChanged$ = new ReplaySubject(5);
    this._groupVisibilities = new ReplaySubject(1);
    this.fieldPositionChanged$ = new ReplaySubject(1);
    this.fieldResized$ = new ReplaySubject(1);
    this.fieldLayoutChanged$ = new ReplaySubject(1);
  }
  init() {

  }
  getEliteFormModel(groupItem: PageGroupItem, question: any) {
    question.title = question.title ? question.title : question.Title;
    question.dataType = question.dataType ? question.dataType : question.DataType;
    question.fieldValues = question.fieldValues ? question.fieldValues : question.FieldValues;
    question.id = question.id ? question.id : question.Id;
    question.isMandatory = question.isMandatory ? question.isMandatory : question.IsMandatory;

    const length = groupItem?.columnSpan ? groupItem?.columnSpan : 12;

    const designModel: DesignItemModel = {
      id: question.id,
      pageGroupItemId : groupItem.id,
      groupId: groupItem.metaData['ChildPageModelId'],
      parentId: groupItem.parentId,
      fieldKey: question.fieldKey,
      title: question.title,
      instruction: question.instruction,
      isMandatory: isMandatory(groupItem),
      dataType: question.dataType,
      y: groupItem.row,
      x: groupItem.column,
      rows: groupItem.rowSpan,
      cols: groupItem.columnSpan,
      positionChanged$: this.fieldPositionChanged$,
      sizeChanged$: this.fieldResized$,
      layoutChanged$: this.fieldLayoutChanged$,
      styleClassName: '',
      metaData: {},
      flowChartId: groupItem.metaData['FlowchartId'],
      flowChartSectionId: groupItem.metaData['FlowChartSectionId'],
    };
    designModel.metaData = question.fieldValues;
    return designModel;
  }
  fieldVisibilityChanged$(): Subject<any>{
    return this._fieldVisibilities;
  }
  updateFieldVisibilityStatus(visibilities: any) {
    this._fieldVisibilities.next(visibilities);
  }
  formChanged$(): Subject<any>{
    return this._formChanged$;
  }
  updateForm(form: any) {
    this._formChanged$.next(form);
  }
  groupVisibilityChanged$(): Subject<any> {
    return this._groupVisibilities;
  }

  updateGroupVisibilityStatus(visibilities: any) {
    return this._groupVisibilities.next(visibilities);
  }
  destroy() {
    this._formChanged$.complete();
    this._fieldVisibilities.complete();
    this._groupVisibilities.complete();
    this.fieldLayoutChanged$.complete();
    this.fieldPositionChanged$.complete();
    this.fieldResized$.complete();
  }
}
function isMandatory(groupItem: PageGroupItem): boolean {
  return groupItem.validators && groupItem.validators.some(v => v.key === 'Required');
}

